import { useMutation } from '@apollo/client';
import {
    ModalContent,
    ModalTitle,
    PrimaryButton,
    ResponsiveSidebarDialog,
    SecondaryButton,
    StickyModalActions,
} from '@/styles/blocks';
import { css } from '@emotion/react';
import { captureException } from '@sentry/react';
import { Grid, IconButton, MenuItem, TextField } from '@material-ui/core';
import { Body1, SectionHeader } from '../../blocks';
import { UPDATE_CLAIM } from '../../ClaimDetails/graphql';
import React, { useMemo, useContext } from 'react';
import { UserContext } from '@/components/App';

const PreApproveClaimModal = ({ claim, open, onClose, onSave, callbacks, editing = false }) => {
    const { user } = useContext(UserContext);

    const [updateClaim, { loading: saveInFlight }] = useMutation(UPDATE_CLAIM, {
        onError: (error) => {
            console.error(error);
            captureException(error);
            callbacks.setNotification({
                severity: 'error',
                message: `Failed to update claim. ${error.message}`,
            });
        },
    });

    const onPreApprove = () => {
        updateClaim({
            variables: {
                claim_id: claim.claim_id,
                update: {
                    claim_status: 'PRE_APPROVED',
                    completed_by: user.user_id,
                },
            },
        }).then(() => {
            onSave();
        });
    };

    if (!claim) return null;

    return (
        <ResponsiveSidebarDialog open={open} onClose={onClose}>
            <ModalTitle title={'Pre-Approve Claim'} onClose={onClose} />
            <ModalContent
                css={css`
                    width: 600px;
                `}
            >
                <Grid container direction="column" css={css``}>
                    <Grid container>
                        <Grid item>
                            <Body1>
                                Pre-Approving a claim allows the user to accept the claim whilst adding adjustments or
                                reimbursements at a later time.
                            </Body1>
                        </Grid>
                    </Grid>
                </Grid>
            </ModalContent>
            <StickyModalActions>
                <Grid item>
                    <SecondaryButton disabled={saveInFlight} onClick={onClose}>
                        Cancel
                    </SecondaryButton>
                </Grid>
                <Grid item>
                    <PrimaryButton disabled={saveInFlight} onClick={onPreApprove}>
                        Pre-Approve
                    </PrimaryButton>
                </Grid>
            </StickyModalActions>
        </ResponsiveSidebarDialog>
    );
};

export default PreApproveClaimModal;
